
import ResponsiveDialog from "../dialogs/responsive-dialog.vue";

const CANCEL_OPTIONS = [
  { id: "waiting_long", label: "Waiting time is too long" },
  { id: "rider_cancel", label: "Rider asked to cancel" },
  { id: "rider_unreachable", label: "Rider is not reachable" },
  { id: "not_coming", label: "Rider is not coming for pickup" }
];

export default {
  components: { ResponsiveDialog },
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedReason: null,
      cancelOptions: CANCEL_OPTIONS,
      showErrorText: false
    };
  },
  methods: {
    submitReason() {
      if (!this.selectedReason) {
        this.showErrorText = true;
        return;
      }

      this.showErrorText = false;
      this.$emit("submit-reason", this.selectedReason);
    }
  }
};
